/* NZS nav skeleton — page-type-aware wireframe overlay shown during full-page navigation.
   Server-rendered theme: the old page stays on screen during the click->response gap, so we
   deliberately overlay a destination-shaped skeleton (cleared automatically when the new doc loads).
   B0 WARM-HANDOFF COUPLING: layout/theme.liquid consumes sessionStorage.nzsSkNav. Never persist
   nzs-nav-sk--bar here, and keep the matching bootstrap guard that rejects a carried bar overlay.
   Vanilla, no deps. Loaded with `defer` from layout/theme.liquid. Kill switch: window.__nzsNavSkOff=true. */
(function(){
  if (window.Shopify && Shopify.designMode) return;   // theme editor: never obscure the canvas
  if (window.__nzsNavSkOff) return;                    // global kill switch
  if (window.__nzsNavSk) return; window.__nzsNavSk = 1;

  var DELAY = 150, SAFETY = 8000, t = null, safety = null, statusTick = null, el = null, statusEl = null;
  var inertRoot = null, inertSet = false, focusEl = null;
  var HAS = Object.prototype.hasOwnProperty;
  var SELF_KEY = 'nzsSkSuffix:';

  var PAGE_KIND = {"about":"art","best-energy-drinks-nz":"compare","best-pre-workout-nz":"compare","best-protein-powder-nz":"compare","blakes-stack":"stack","build-your-stack":"stack","compare":"compare","contact":"art","contact-company":"art","energy-focus-stack":"stack","everyday-health-stack":"stack","faq":"art","favourites":"coll","featured-pre-workout":"coll","find-your-pre-workout":"quiz","find-your-stack":"quiz","fuel-your-whole-day":"stack","gym-starter-stack":"stack","muscle-size-stack":"stack","shop-by-brand":"shopidx","shop-by-category":"shopidx","shop-by-goal":"shopidx","shred-lean-stack":"stack","sleep-recovery-stack":"stack","track-my-order":"art","winter-immunity-stack":"stack","wishlist":"coll","your-stack":"review"};
  var SUFFIX_KIND = {"":"art","about":"art","blakes-stack":"stack","compare":"compare","contact":"art","day-stack":"stack","energy-compare":"compare","energy-stack":"stack","faq":"art","favourites":"coll","featured-pre-workout":"coll","find-your-pre-workout":"quiz","find-your-stack":"quiz","health-stack":"stack","immunity-stack":"stack","muscle-stack":"stack","none":"art","protein-compare":"compare","pw-compare":"compare","shop-by-brand":"shopidx","shop-by-category":"shopidx","shop-by-goal":"shopidx","shred-stack":"stack","sleep-stack":"stack","stack-builder":"stack","starter-stack":"stack","track-my-order":"art","wishlist":"coll","your-stack":"review"};

  function fill(n, s){ var o = ''; while (n-- > 0) o += s; return o; }
  var PRODUCT_CARD = '<div class="nzs-sk-product-card">'+
    '<div class="nzs-sk nzs-sk-product-card__media"></div>'+
    '<div class="nzs-sk nzs-sk-product-card__title"></div>'+
    '</div>';
  var COLLECTION_TILE = '<div class="nzs-sk-collection-tile">'+
    '<div class="nzs-sk nzs-sk-collection-tile__media"></div>'+
    '<div class="nzs-sk nzs-sk-collection-tile__title"></div>'+
    '</div>';
  var SUBCOLLECTION_TILE = '<div class="nzs-sk-subc-tile">'+
    '<div class="nzs-sk nzs-sk-subc-tile__media"></div>'+
    '<div class="nzs-sk nzs-sk-subc-tile__name"></div>'+
    '<div class="nzs-sk nzs-sk-subc-tile__count"></div>'+
    '</div>';
  var STACK_ROW = '<div class="nzs-sk-stack-card">'+
    '<div class="nzs-sk nzs-sk-stack-img"></div>'+
    '<div class="nzs-sk-stack-copy"><div class="nzs-sk nzs-sk-stack-title"></div></div>'+
    '</div>';
  var CART_ROW = '<div class="nzs-sk-cart-row">'+
    '<div class="nzs-sk nzs-sk-cart-row__media"></div>'+
    '<div class="nzs-sk-cart-row__copy"><div class="nzs-sk nzs-sk-cart-row__title"></div></div>'+
    '</div>';
  var BLOG_CARD = '<div class="nzs-sk-blog-card">'+
    '<div class="nzs-sk nzs-sk-blog-card__media"></div>'+
    '<div class="nzs-sk nzs-sk-blog-card__title"></div>'+
    '</div>';
  var INDEX_CARD = '<div class="nzs-sk-index-card">'+
    '<div class="nzs-sk nzs-sk-index-card__media"></div>'+
    '<div class="nzs-sk nzs-sk-index-card__title"></div>'+
    '</div>';

  var TPL = {
    pdp:  '<div class="nzs-nav-sk__wrap">'+
            '<div class="nzs-sk nzs-sk-gal"></div>'+
            '<div class="nzs-sk-col">'+
              '<div class="nzs-sk nzs-sk-bar"></div>'+
              '<div class="nzs-sk nzs-sk-bar"></div>'+
              '<div class="nzs-sk nzs-sk-bar nzs-sk--w80"></div>'+
              '<div class="nzs-sk nzs-sk-btn"></div>'+
            '</div>'+
          '</div>',
    coll: '<div class="nzs-sk-collhero">'+
            '<div class="nzs-sk-collhero__in">'+
              '<div class="nzs-sk nzs-sk-on-dark nzs-sk-collhero__title"></div>'+
              '<div class="nzs-sk nzs-sk-on-dark nzs-sk-collhero__count"></div>'+
            '</div>'+
          '</div>'+
          '<div class="nzs-nav-sk__wrap">'+
            '<div class="nzs-sk-subc">'+
              '<div class="nzs-sk nzs-sk-subc__heading"></div>'+
              '<div class="nzs-sk-subc__bar"></div>'+
              '<div class="nzs-sk-subc__row">'+ fill(6, SUBCOLLECTION_TILE) +'</div>'+
            '</div>'+
            '<div class="nzs-sk nzs-sk-toolbar"></div>'+
            '<div class="nzs-sk-grid nzs-sk-product-grid">'+ fill(8, PRODUCT_CARD) +'</div>'+
          '</div>',
    art:  '<div class="nzs-nav-sk__wrap nzs-sk-article">'+
            '<div class="nzs-sk-article__head">'+
              '<div class="nzs-sk nzs-sk-article__title"></div>'+
              '<div class="nzs-sk nzs-sk-article__lead"></div>'+
              '<div class="nzs-sk nzs-sk-article__meta"></div>'+
            '</div>'+
            '<div class="nzs-sk nzs-sk-article__hero"></div>'+
            '<div class="nzs-sk-article__body">'+ fill(7, '<div class="nzs-sk nzs-sk-bar"></div>') +'</div>'+
          '</div>',
    cart: '<div class="nzs-nav-sk__wrap">'+
            '<div class="nzs-sk nzs-sk-cart-heading"></div>'+
            '<div class="nzs-sk-cart-layout">'+
              '<div class="nzs-sk-cart-lines">'+ fill(3, CART_ROW) +'</div>'+
              '<div class="nzs-sk-cart-summary">'+
                '<div class="nzs-sk nzs-sk-bar"></div>'+
                '<div class="nzs-sk nzs-sk-bar nzs-sk--w80"></div>'+
                '<div class="nzs-sk nzs-sk-bar nzs-sk--w60"></div>'+
                '<div class="nzs-sk nzs-sk-btn"></div>'+
              '</div>'+
            '</div>'+
          '</div>',
    account: '<div class="nzs-nav-sk__wrap">'+
            '<div class="nzs-sk nzs-sk-account-heading"></div>'+
            '<div class="nzs-sk-account-layout">'+
              '<div class="nzs-sk-account-orders">'+
                '<div class="nzs-sk nzs-sk-account-subheading"></div>'+
                '<div class="nzs-sk nzs-sk-account-tablehead"></div>'+
                fill(4, '<div class="nzs-sk nzs-sk-account-row"></div>')+
              '</div>'+
              '<div class="nzs-sk-account-detail">'+
                '<div class="nzs-sk nzs-sk-account-subheading"></div>'+
                fill(3, '<div class="nzs-sk nzs-sk-bar"></div>')+
              '</div>'+
            '</div>'+
          '</div>',
    review: '<div class="nzs-nav-sk__wrap nzs-sk-review-wrap">'+
            '<div class="nzs-sk-review-steps">'+ fill(2, '<div class="nzs-sk nzs-sk-review-step"></div>') +'</div>'+
            '<div class="nzs-sk nzs-sk-review-title"></div>'+
            '<div class="nzs-sk nzs-sk-review-lead"></div>'+
            '<div class="nzs-sk-review-grid">'+
              '<div class="nzs-sk-review-lines">'+ fill(5, CART_ROW) +'</div>'+
              '<div class="nzs-sk-review-summary">'+
                '<div class="nzs-sk nzs-sk-bar"></div>'+
                '<div class="nzs-sk nzs-sk-bar nzs-sk--w80"></div>'+
                '<div class="nzs-sk nzs-sk-bar nzs-sk--w60"></div>'+
                '<div class="nzs-sk nzs-sk-btn"></div>'+
              '</div>'+
            '</div>'+
          '</div>',
    home: '<div class="nzs-sk-home-hero">'+
            '<div class="nzs-sk-home-copy">'+
              '<div class="nzs-sk nzs-sk-home-kicker"></div>'+
              '<div class="nzs-sk nzs-sk-home-title"></div>'+
              '<div class="nzs-sk nzs-sk-home-title nzs-sk--w80"></div>'+
              '<div class="nzs-sk nzs-sk-home-cta"></div>'+
            '</div>'+
            '<div class="nzs-sk nzs-sk-home-photo"></div>'+
          '</div>'+
          '<div class="nzs-sk-home-trust">'+
            '<div class="nzs-nav-sk__wrap nzs-sk-home-trust__items">'+
              fill(3, '<div class="nzs-sk nzs-sk-on-brand nzs-sk-home-trust__item"></div>')+
            '</div>'+
          '</div>'+
          '<div class="nzs-nav-sk__wrap nzs-sk-home-cspot">'+
            '<div class="nzs-sk nzs-sk-home-cspot__heading"></div>'+
            '<div class="nzs-sk-home-cspot__grid">'+
              '<div class="nzs-sk-home-cspot__list">'+ fill(6, '<div class="nzs-sk nzs-sk-home-cspot__name"></div>') +'</div>'+
              '<div class="nzs-sk nzs-sk-home-cspot__stage"></div>'+
            '</div>'+
          '</div>',
    /* NZS-COMPARE-SK: /pages/compare -- heading, lead, tab pills, toolbar, card grid */
    compare: '<div class="nzs-nav-sk__wrap">'+
            '<div class="nzs-sk nzs-sk-cmp-h1"></div>'+
            '<div class="nzs-sk nzs-sk-cmp-lead"></div>'+
            '<div class="nzs-sk nzs-sk-cmp-lead nzs-sk-cmp-lead--short"></div>'+
            '<div class="nzs-sk-cmp-tabs">'+ fill(8, '<div class="nzs-sk nzs-sk-cmp-tab"></div>') +'</div>'+
            '<div class="nzs-sk-cmp-bar"><div class="nzs-sk nzs-sk-cmp-fil"></div><div class="nzs-sk nzs-sk-cmp-sort"></div></div>'+
            '<div class="nzs-sk-grid nzs-sk-product-grid nzs-sk-cmp-grid">'+ fill(8, PRODUCT_CARD) +'</div>'+
          '</div>',
    search: '<div class="nzs-nav-sk__wrap">'+
            '<div class="nzs-sk nzs-sk-search-heading"></div>'+
            '<div class="nzs-sk-search-field">'+
              '<div class="nzs-sk nzs-sk-search-field__input"></div>'+
              '<div class="nzs-sk nzs-sk-search-field__button"></div>'+
            '</div>'+
            '<div class="nzs-sk nzs-sk-toolbar"></div>'+
            '<div class="nzs-sk-grid nzs-sk-product-grid">'+ fill(8, PRODUCT_CARD) +'</div>'+
          '</div>',
    stack: '<div class="nzs-nav-sk__wrap">'+
            '<div class="nzs-sk nzs-sk-stack-h1"></div>'+
            '<div class="nzs-sk nzs-sk-stack-intro"></div>'+
            '<div class="nzs-sk-stack-split">'+
              '<div class="nzs-sk-stack-list">'+ fill(4, STACK_ROW) +'</div>'+
              '<div class="nzs-sk nzs-sk-stack-bundle"></div>'+
            '</div>'+
            '<div class="nzs-sk-stack-summary">'+ fill(3, '<div class="nzs-sk nzs-sk-bar"></div>') +'<div class="nzs-sk nzs-sk-btn"></div></div>'+
          '</div>',
    quiz: '<div class="nzs-nav-sk__wrap">'+
            '<div class="nzs-sk-quiz-head">'+
              '<div class="nzs-sk nzs-sk-quiz-h1"></div>'+
              '<div class="nzs-sk nzs-sk-quiz-lead"></div>'+
              '<div class="nzs-sk nzs-sk-quiz-cta"></div>'+
            '</div>'+
            '<div class="nzs-sk-quiz-section-heading"><div class="nzs-sk nzs-sk-bar"></div></div>'+
            '<div class="nzs-sk-quiz-steps">'+ fill(3, '<div class="nzs-sk-quiz-step"><div class="nzs-sk nzs-sk-quiz-step__num"></div><div class="nzs-sk nzs-sk-quiz-step__title"></div></div>') +'</div>'+
            '<div class="nzs-sk-quiz-section-heading"><div class="nzs-sk nzs-sk-bar"></div></div>'+
            '<div class="nzs-sk-quiz-goals">'+ fill(6, '<div class="nzs-sk-quiz-goal"><div class="nzs-sk nzs-sk-quiz-goal__media"></div><div class="nzs-sk nzs-sk-quiz-goal__title"></div></div>') +'</div>'+
          '</div>',
    listcoll: '<div class="nzs-sk-list-hero"><div class="nzs-sk nzs-sk-list-hero__title"></div></div>'+
          '<div class="nzs-nav-sk__wrap nzs-sk-list-body">'+
            '<div class="nzs-sk-grid nzs-sk-list-grid">'+ fill(10, COLLECTION_TILE) +'</div>'+
          '</div>',
    shopidx: '<div class="nzs-nav-sk__wrap nzs-sk-index">'+
            '<div class="nzs-sk-index__head">'+
              '<div class="nzs-sk nzs-sk-index__title"></div>'+
              '<div class="nzs-sk nzs-sk-index__intro"></div>'+
              '<div class="nzs-sk nzs-sk-index__intro nzs-sk--w60"></div>'+
            '</div>'+
            '<div class="nzs-sk-grid nzs-sk-index-grid">'+ fill(8, INDEX_CARD) +'</div>'+
          '</div>',
    blog: '<div class="nzs-nav-sk__wrap nzs-sk-blog">'+
            '<div class="nzs-sk-blog__head">'+
              '<div class="nzs-sk nzs-sk-blog__title"></div>'+
              '<div class="nzs-sk nzs-sk-blog__intro"></div>'+
            '</div>'+
            '<div class="nzs-sk-blog-featured">'+
              '<div class="nzs-sk nzs-sk-blog-featured__media"></div>'+
              '<div class="nzs-sk-blog-featured__body"><div class="nzs-sk nzs-sk-blog-featured__title"></div><div class="nzs-sk nzs-sk-blog-featured__line"></div><div class="nzs-sk nzs-sk-blog-featured__line nzs-sk--w60"></div></div>'+
            '</div>'+
            '<div class="nzs-sk-blog-chips">'+ fill(5, '<div class="nzs-sk nzs-sk-blog-chip"></div>') +'</div>'+
            '<div class="nzs-sk-grid nzs-sk-blog-grid">'+ fill(6, BLOG_CARD) +'</div>'+
          '</div>',
    bar:  ''                                            // unmatched: top progress bar only
  };

  (function assertTemplates(){
    function safeMap(map, label){
      if (!map || typeof map !== 'object') {
        if (window.console && console.error) console.error('[nzs-skeleton] invalid ' + label + '; using bar fallback');
        return {};
      }
      for (var key in map) {
        if (HAS.call(map, key) && !HAS.call(TPL, map[key])) {
          if (window.console && console.error) console.error('[nzs-skeleton] missing TPL for ' + label + ' kind "' + map[key] + '"; using bar fallback');
          map[key] = 'bar';
        }
      }
      return map;
    }
    PAGE_KIND = safeMap(PAGE_KIND, 'PAGE_KIND');
    SUFFIX_KIND = safeMap(SUFFIX_KIND, 'SUFFIX_KIND');
  })();

  function routeRoot(){
    var root = '/';
    try {
      root = window.Shopify && Shopify.routes && typeof Shopify.routes.root === 'string' ? Shopify.routes.root : '/';
      root = new URL(root || '/', location.origin).pathname;
    } catch (_){ root = '/'; }
    if (root.charAt(0) !== '/') root = '/' + root;
    return root.replace(/\/+$/, '') || '/';
  }

  function normalise(pathname){
    var p = typeof pathname === 'string' && pathname ? pathname : '/';
    try { p = new URL(p, location.href).pathname; } catch (_){}
    if (p.charAt(0) !== '/') p = '/' + p;
    p = p.replace(/\/+$/, '') || '/';
    var root = routeRoot();                            // root is trailing-slash-normalised before comparison
    if (root !== '/' && (p === root || p.indexOf(root + '/') === 0)) p = p.slice(root.length) || '/';
    return p.replace(/\/+$/, '') || '/';              // stripping the locale root can produce an empty string
  }

  function healedKind(path){
    var suffix = null, healed;
    try { suffix = sessionStorage.getItem(SELF_KEY + path); } catch (_){}
    if (suffix === null) return null;
    healed = HAS.call(SUFFIX_KIND, suffix) ? SUFFIX_KIND[suffix] : 'bar';
    return HAS.call(TPL, healed) ? healed : 'bar';
  }

  function rememberCurrentSuffix(){
    var main = document.getElementById('MainContent');
    if (!main) return;
    var marker = 'theme-template-suffix-', classes = String(main.className || '').split(/\s+/), suffix = null;
    for (var i = 0; i < classes.length; i++) {
      if (classes[i].indexOf(marker) === 0) { suffix = classes[i].slice(marker.length); break; }
    }
    if (suffix === null) return;
    try { sessionStorage.setItem(SELF_KEY + normalise(location.pathname), suffix); } catch (_){}
  }

  function kind(pathname){
    var p = normalise(pathname), m, mapped, healed;
    if (/^\/$/.test(p))                                      return 'home';
    if (/^\/products\/[^/]+$/.test(p))                       return 'pdp';
    if (/^\/collections\/[^/]+\/products\/[^/]+$/.test(p))   return 'pdp';
    if (/^\/collections$/.test(p))                           return 'listcoll';
    if (/^\/collections\/[^/]+$/.test(p))                    return 'coll';
    if (/^\/search$/.test(p))                                return 'search';
    m = p.match(/^\/pages\/([^/]+)$/);
    if (m) {
      mapped = PAGE_KIND && typeof PAGE_KIND === 'object' ? PAGE_KIND[m[1]] : null;
      if (typeof mapped === 'string' && HAS.call(TPL, mapped)) return mapped;
      healed = healedKind(p);
      return healed || 'bar';
    }
    if (/^\/blogs\/[^/]+\/tagged\/[^/]+$/.test(p))           return 'blog';
    if (/^\/blogs\/[^/]+$/.test(p))                          return 'blog';
    if (/^\/blogs\/[^/]+\/[^/]+$/.test(p))                   return 'art';
    if (/^\/policies\/[^/]+$/.test(p))                       return 'art';
    if (/^\/cart$/.test(p))                                  return 'cart';
    if (/^\/account(?:\/|$)/.test(p))                         return 'account';
    return 'bar';
  }

  function destination(u){
    if (normalise(u.pathname) === normalise(location.pathname)) return 'bar';
    return kind(u.pathname);
  }

  function darkNow(){
    if (document.documentElement && document.documentElement.classList.contains('dark')) return true;
    try { return String(localStorage.eurus_theme) === '1'; } catch (_){ return false; }
  }

  function prepareInert(k){
    if (k === 'bar') return k;
    var main = document.querySelector('.main-container');
    if (!main || !('inert' in main)) return 'bar';
    inertRoot = main;
    inertSet = !main.inert;
    focusEl = main.contains(document.activeElement) ? document.activeElement : null;
    if (inertSet) main.inert = true;
    return k;
  }

  function show(k){
    if (el) return;                                     // never stack overlays
    /* NZS-SK-CLOSESURF-0821 (Blake): dismiss any open header overlay (search, mega, mobile nav)
       the instant a navigation commits, BEFORE the wireframe paints — so clicking a product/
       collection out of the search panel no longer skeleton-loads with the search still covering
       the page. Uses each surface's own closer (state stays consistent); '' matches no key, so
       every registered surface closes. No-op when nothing is open. */
    /* NZS-SKCLOSE-0903 (Blake): html.nzs-sk-on kills transitions (nzs-base.css) so those closes
       are instant - no drawer/pane sliding away while the next page loads. hide() removes it. */
    document.documentElement.classList.add('nzs-sk-on');
    try { if (window.__nzsCloseAllExcept) window.__nzsCloseAllExcept(''); } catch (_){}
    k = prepareInert(k);                               // unsupported inert must use the non-opaque bar
    el = document.createElement('div');
    el.className = 'nzs-nav-sk nzs-nav-sk--' + k + (darkNow() && k !== 'bar' ? ' nzs-nav-sk--dark' : '');
    el.setAttribute('aria-hidden', 'true');
    /* NZS-SK-BELOW-HEADER (Blake 2026-07-31): --nzs-sk-top was a hardcoded 88px, but the
       header is a fixed 110px (105px mid-breakpoint) since it stopped shrinking on scroll,
       so the overlay began inside the header and clipped its lower edge. Measure the real
       thing instead of trusting a constant — this then tracks any future header change and
       every breakpoint for free. The inline value rides along in the sessionStorage
       outerHTML used for the warm handoff, which is correct: the next document's header is
       the same height. */
    var _hdr = document.querySelector('.site-header');
    var _hdrH = _hdr ? Math.round(_hdr.getBoundingClientRect().height) : 0;
    if (_hdrH > 0) el.style.setProperty('--nzs-sk-top', _hdrH + 'px');
    el.innerHTML = TPL[k] || ''; /* NZS-SKBAR-0903: no progress bar */
    document.body.appendChild(el);
    if (statusTick){ clearTimeout(statusTick); statusTick = null; }
    statusTick = setTimeout(function(){
      statusTick = null;
      if (statusEl) statusEl.textContent = 'Loading page';
    }, 0);

    try {
      if (k === 'bar') sessionStorage.removeItem('nzsSkNav');
      else sessionStorage.setItem('nzsSkNav', el.outerHTML);
    } catch (_){}
    safety = setTimeout(hide, SAFETY);                  // retain id so every terminal path can clear it
  }

  function hide(){
    document.documentElement.classList.remove('nzs-sk-on');
    try { sessionStorage.removeItem('nzsSkNav'); } catch (_){}
    if (safety){ clearTimeout(safety); safety = null; }
    if (statusTick){ clearTimeout(statusTick); statusTick = null; }
    if (el && el.parentNode) el.parentNode.removeChild(el);
    if (statusEl) statusEl.textContent = '';
    el = null;
    if (inertRoot && inertSet) inertRoot.inert = false;
    var restore = focusEl;
    inertRoot = null;
    inertSet = false;
    focusEl = null;
    if (restore && restore.isConnected !== false && typeof restore.focus === 'function') {
      try { restore.focus({ preventScroll: true }); } catch (_) { try { restore.focus(); } catch (__) {} }
    }
    if (t){ clearTimeout(t); t = null; }
  }

  statusEl = document.createElement('span');            // persistent body sibling: the overlay is aria-hidden
  statusEl.className = 'nzs-nav-sk__status';
  statusEl.setAttribute('role', 'status');
  statusEl.setAttribute('aria-live', 'polite');
  statusEl.setAttribute('aria-atomic', 'true');
  document.body.appendChild(statusEl);
  rememberCurrentSuffix();

  /* NZS-OFFERS-0820 r3: programmatic navigation with the skeleton — the cart drawer's
     Recently-Viewed pane closes the drawer first, then calls this to show the wireframe and go. */
  window.__nzsNavSkTo = function(href){
    var u; try { u = new URL(href, location.href); } catch (_) { location.assign(href); return; }
    try { show(destination(u)); } catch (_) {}
    location.assign(u.href);
  };
  document.addEventListener('click', function(e){
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    if (a.target && a.target !== '_self') return;       // opens new tab/frame
    if (a.hasAttribute('download') || a.hasAttribute('data-no-skeleton')) return;
    if (a.closest('[data-no-skeleton]')) return;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|sms:|javascript:)/i.test(href)) return;
    var u; try { u = new URL(a.href, location.href); } catch (_){ return; }
    if (u.origin !== location.origin) return;                                   // cross-origin
    if (u.pathname === location.pathname && u.search === location.search) return; // same page / hash jump
    if (/\/checkout(\/|$)/.test(u.pathname)) return;                            // checkout only (account shows the skeleton)
    var dest = destination(u);
    // Fire after a short delay so fast loads never flash; at fire-time re-check defaultPrevented so
    // client-intercepted links (filters, swatches, quick-view, cart toggle — all call preventDefault
    // in the bubble phase, after this capture handler) never leave a stuck overlay.
    if (t){ clearTimeout(t); t = null; }
    t = setTimeout(function(){ t = null; if (!e.defaultPrevented) show(dest); }, DELAY);
  }, true);

  window.addEventListener('pageshow', function(ev){ if (ev.persisted) hide(); }); // bfcache Back
  window.addEventListener('popstate', hide);
})();
